import React from 'react'

const ErrorMessage = ({ isError, message ,className }) => {
  return (
    <>
      {isError && <div className={`absolute mt-1 z-10 bottom-[-12px] left-[15px] px-2 bg-red-100 font-semibold text-red-700 rounded-md border border-red-300 shadow-md transition-opacity duration-300 text-[13px] ${className}` }>
        {message}
        <div className="absolute -top-[6px] left-4 w-3 h-3 bg-red-100 transform rotate-45 border-l border-t border-red-300"></div>
      </div>}
    </>
  )
}

export default ErrorMessage